var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/app.module.ts.pre-build-optimizer.js